function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0552 11.3294C20.0552 16.2997 16.0254 20.3294 11.0552 20.3294C6.08493 20.3294 2.05518 16.2997 2.05518 11.3294C2.05518 6.35916 6.08493 2.32941 11.0552 2.32941C16.0254 2.32941 20.0552 6.35916 20.0552 11.3294Z",
  fill: "#E6E6E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0771 4.59143C11.2761 4.59143 11.4668 4.67045 11.6075 4.8111C11.7481 4.95175 11.8271 5.14252 11.8271 5.34143V11.3377C11.8271 11.5366 11.7481 11.7274 11.6075 11.868C11.4668 12.0087 11.2761 12.0877 11.0771 12.0877C10.8782 12.0877 10.6875 12.0087 10.5468 11.868C10.4062 11.7274 10.3271 11.5366 10.3271 11.3377V5.34143C10.3271 5.14252 10.4062 4.95175 10.5468 4.8111C10.6875 4.67045 10.8782 4.59143 11.0771 4.59143Z",
  fill: "#CA0B4A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.604 13.9424C15.5046 14.1146 15.3408 14.2403 15.1486 14.2918C14.9565 14.3433 14.7518 14.3163 14.5795 14.2169L10.7035 11.9789C10.6175 11.93 10.5421 11.8646 10.4815 11.7864C10.4209 11.7083 10.3763 11.6189 10.3504 11.5234C10.3245 11.428 10.3177 11.3283 10.3305 11.2302C10.3432 11.1321 10.3752 11.0376 10.4247 10.9519C10.4742 10.8662 10.5401 10.7912 10.6186 10.7311C10.6972 10.671 10.7869 10.6271 10.8825 10.6018C10.9781 10.5765 11.0778 10.5704 11.1758 10.5838C11.2738 10.5972 11.3682 10.6299 11.4535 10.6799L15.3295 12.9179C15.5018 13.0174 15.6275 13.1812 15.679 13.3733C15.7304 13.5654 15.7035 13.7701 15.604 13.9424Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0552 19.5794C15.6114 19.5794 19.3052 15.8857 19.3052 11.3294C19.3052 6.77316 15.6114 3.07941 11.0552 3.07941C6.49893 3.07941 2.80518 6.77316 2.80518 11.3294C2.80518 15.8857 6.49893 19.5794 11.0552 19.5794ZM11.0552 21.8294C5.25618 21.8294 0.555176 17.1284 0.555176 11.3294C0.555176 5.53041 5.25618 0.829407 11.0552 0.829407C16.8542 0.829407 21.5552 5.53041 21.5552 11.3294C21.5552 17.1284 16.8542 21.8294 11.0552 21.8294Z",
  fill: "#636363"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5704 11.3376C12.5704 11.7333 12.4132 12.1127 12.1335 12.3925C11.8537 12.6722 11.4743 12.8294 11.0787 12.8294C10.683 12.8294 10.3036 12.6722 10.0238 12.3925C9.74408 12.1127 9.58691 11.7333 9.58691 11.3376C9.58691 10.942 9.74408 10.5626 10.0238 10.2828C10.3036 10.0031 10.683 9.84589 11.0787 9.84589C11.4743 9.84589 11.8537 10.0031 12.1335 10.2828C12.4132 10.5626 12.5704 10.942 12.5704 11.3376Z",
  fill: "#9B9B9B"
});

function SvgClockColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockColor);
export default __webpack_public_path__ + "static/media/clock-color.16134b21d426064bd86afe0bd3dbc233.svg";
export { ForwardRef as ReactComponent };